import React from "react";
import { Link } from "react-router-dom";
import { AppRoutes } from "views/components/constants/routes";

export const accordionData = [
  {
    title: "What is the Taskgo Pharmacy AI Software?",
    content: (
      <>
        We developed industry specific software to manage administrative workload,
        and scale pharmacy services within less efforts. From standard operating
        procedures (SOPs), all PSI required logs, to managing medication orders
        and service bookings, we&apos;ve got you covered. Click{" "}
        <Link to={AppRoutes.pharmacyAi}>here</Link> to learn more.
      </>
    ),
  },
  {
    title: "What is the Vigilion Cybersecurity services?",
    content:
      "We operate as a Managed Security Services Provider (MSSP) for healthcare organisations. This enables teams to reduce risk, improve visibility across their IT environments, and maintain confidence in their security posture whilst focusing on delivering patient care.",
  },
  {
    title: "I already have a website, how easy is it to change? ",
    content:
      "If you already have a website then that's great. This means we can develop your new website whilst your other website is still live. Once we are ready, the swap can take as little as 10 minutes",
  },
  {
    title: "Will you tell me how to run my business? ",
    content:
      "No, that's not what we do. We bring in an outside view, other experience, ask questions, present solutions, and work with your business on whatever it needs",
  },
];

export const Data = [
  {
    title: "What is a business consultant? ",
    content:
      "A business consultant is someone who works with management to solve organisational problems, find opportunities for improvements, and implement effective solutions",
  },
  {
    title: "Why would I use a business consultant?",
    content:
      "When you have a challenge to solve, when you are looking for ways to grow, when you need to reduce costs or improve productivity and when you need to innovate or deliver significant organisational change",
  },
  {
    title: "Why should I choose to work with taskgo?",
    content:
      "There are so many business consultants but how many actually understand pharmacy. We work on the front line every day and so understand the market needs. It ultimately comes down to needs and trust.",
  },
  {
    title: "Who do you work with? ",
    content:
      "We only take on clients who are serious about growth. We offer a free 30 minute consultation and try to understand your needs before deciding to bring on a new client. We limit the number of clients we work with at any given moment so that we can maximise our client benefits.",
  },
];
